import React from "react"
import { BrowserRouter, Route, Routes } from "react-router"
import { MobileAppBar } from "../components/AppBar"
import Driver from "../pages/driver/index"
import Form from "../pages/form/index"
import Job from "../pages/job"
import JobListing from "../pages/job-listing/index"
import Sites from "../pages/sites/index"
import UserLounge from "../pages/user-lounge/index"
import Vehicle from "../pages/vehicle/index"
import Notification from "../pages/notification/index"
import BottomBar from "../components/BottomBar"
import Conversation from "../pages/conversation/index"
import ShiftTracking from "../pages/tracking/index"

export const MobileBrowserRouter = () => {
    return (
        <BrowserRouter>
            <MobileAppBar />
            <Routes>
                <Route path="/" element={<UserLounge />} />
                <Route path="/driver" element={<Driver />} />
                <Route path="/vehicle" element={<Vehicle />} />
                <Route path="/sites" element={<Sites />} />
                <Route path="/form" element={<Form />} />
                <Route path="/job-listing" element={<JobListing />} />
                <Route path="/job" element={<Job />} />
                <Route path="/notifications" element={<Notification />} />
                <Route path="/conversations" element={<Conversation />} />
                <Route path="/tracking" element={<ShiftTracking />} />
            </Routes>
            <BottomBar />
        </BrowserRouter>
    )
}
